import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_PROJECT_REQUEST = 'LOAD_PROJECT_REQUEST';
export const LOAD_PROJECT_SUCCESS = 'LOAD_PROJECT_SUCCESS';
export const LOAD_PROJECT_FAIL = 'LOAD_PROJECT_FAIL';

export const LOAD_PROJECTS_LIST_REQUEST = 'LOAD_PROJECTS_LIST_REQUEST';
export const LOAD_PROJECTS_LIST_SUCCESS = 'LOAD_PROJECTS_LIST_SUCCESS';
export const LOAD_PROJECTS_LIST_FAIL = 'LOAD_PROJECTS_LIST_FAIL';

export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAIL = 'CREATE_PROJECT_FAIL';

export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAIL = 'UPDATE_PROJECT_FAIL';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAIL = 'DELETE_PROJECT_FAIL';

export const UPDATE_PROJECT_USERS_REQUEST = 'UPDATE_PROJECT_USERS_REQUEST';
export const UPDATE_PROJECT_USERS_SUCCESS = 'UPDATE_PROJECT_USERS_SUCCESS';
export const UPDATE_PROJECT_USERS_FAIL = 'UPDATE_PROJECT_USERS_FAIL';

export const UPDATE_PROJECT_JOBS_REQUEST = 'UPDATE_PROJECT_JOBS_REQUEST';
export const UPDATE_PROJECT_JOBS_SUCCESS = 'UPDATE_PROJECT_JOBS_SUCCESS';
export const UPDATE_PROJECT_JOBS_FAIL = 'UPDATE_PROJECT_JOBS_FAIL';

export const DELETE_PROJECT_USERS_REQUEST = 'DELETE_PROJECT_USERS_REQUEST';
export const DELETE_PROJECT_USERS_SUCCESS = 'DELETE_PROJECT_USERS_SUCCESS';
export const DELETE_PROJECT_USERS_FAIL = 'DELETE_PROJECT_USERS_FAIL';

export const DELETE_PROJECT_JOBS_REQUEST = 'DELETE_PROJECT_JOBS_REQUEST';
export const DELETE_PROJECT_JOBS_SUCCESS = 'DELETE_PROJECT_JOBS_SUCCESS';
export const DELETE_PROJECT_JOBS_FAIL = 'DELETE_PROJECT_JOBS_FAIL';

export const SET_CURRENT_PROJECT_ID = 'SET_CURRENT_PROJECT_ID';

export const RESET_CURRENT_PROJECT = 'RESET_CURRENT_PROJECT';

const loadListRequest = () => ({ type: LOAD_PROJECTS_LIST_REQUEST });
const loadListSuccess = (list) => ({ type: LOAD_PROJECTS_LIST_SUCCESS, list });
const loadListFail = () => ({ type: LOAD_PROJECTS_LIST_FAIL });

const loadProjectRequest = () => ({ type: LOAD_PROJECT_REQUEST });
const loadProjectSuccess = (project) => ({ type: LOAD_PROJECT_SUCCESS, project });
const loadProjectFail = () => ({ type: LOAD_PROJECT_FAIL });

const createRequest = () => ({ type: CREATE_PROJECT_REQUEST });
const createSuccess = (project) => ({ type: CREATE_PROJECT_SUCCESS, project });
const createFail = () => ({ type: CREATE_PROJECT_FAIL });

const updateRequest = () => ({ type: UPDATE_PROJECT_REQUEST });
const updateSuccess = (project) => ({ type: UPDATE_PROJECT_SUCCESS, project });
const updateFail = () => ({ type: UPDATE_PROJECT_FAIL });

const deleteRequest = () => ({ type: DELETE_PROJECT_REQUEST });
const deleteSuccess = (project) => ({ type: DELETE_PROJECT_SUCCESS, project });
const deleteFail = () => ({ type: DELETE_PROJECT_FAIL });

const updateUsersRequest = () => ({ type: UPDATE_PROJECT_USERS_REQUEST });
const updateUsersSuccess = (associations) => ({ type: UPDATE_PROJECT_USERS_SUCCESS, associations });
const updateUsersFail = () => ({ type: UPDATE_PROJECT_USERS_FAIL });

const updateJobsRequest = () => ({ type: UPDATE_PROJECT_JOBS_REQUEST });
const updateJobsSuccess = (associations) => ({ type: UPDATE_PROJECT_JOBS_SUCCESS, associations });
const updateJobsFail = () => ({ type: UPDATE_PROJECT_JOBS_FAIL });

const deleteUsersRequest = () => ({ type: DELETE_PROJECT_USERS_REQUEST });
const deleteUsersSuccess = (associations) => ({ type: DELETE_PROJECT_USERS_SUCCESS, associations });
const deleteUsersFail = () => ({ type: DELETE_PROJECT_USERS_FAIL });

const deleteJobsRequest = () => ({ type: DELETE_PROJECT_JOBS_REQUEST });
const deleteJobsSuccess = (associations) => ({ type: DELETE_PROJECT_JOBS_SUCCESS, associations });
const deleteJobsFail = () => ({ type: DELETE_PROJECT_JOBS_FAIL });

export const resetCurrentProject = () => (dispatch) => dispatch({ type: RESET_CURRENT_PROJECT });

export const setCurrentProjectId = (id) => (dispatch) => dispatch({ type: SET_CURRENT_PROJECT_ID, id });

export const loadProject = (ids) => (dispatch) => {
  dispatch(loadProjectRequest());
  return communicate({ url: 'Projects', getParams: Utils.objects.getQueryStringFromObject({ ids, status: '', isDeleted: '' }) })
    .then(({ data }) => {
      const project = data.Data.length ? data.Data[0] : {};
      dispatch(loadProjectSuccess(project));
    })
    .catch((err) => {
      dispatch(loadProjectFail());
      toastrError(err);
    });
};

export const loadProjectsList = () => (dispatch) => {
  dispatch(loadListRequest());
  return communicate({ url: 'Projects?status=' })
    .then(({ data }) => dispatch(loadListSuccess(data.Data)))
    .catch((err) => {
      dispatch(loadListFail());
      toastrError(err);
    });
};

export const createProject = (params) => (dispatch) => {
  dispatch(createRequest());
  return communicate({ url: 'Projects', method: 'post', data: params })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(createSuccess(data.Data));
    })
    .catch((err) => {
      dispatch(createFail());
      toastrError(err);
    });
};

export const updateProject = (params) => (dispatch) => {
  dispatch(updateRequest());
  return communicate({ url: 'Projects', method: 'put', data: params })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(updateSuccess(data.Data));
    })
    .catch((err) => {
      dispatch(updateFail());
      toastrError(err);
    });
};

export const deleteProject = (params) => (dispatch) => {
  dispatch(deleteRequest());
  return communicate({ url: 'Projects', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(deleteSuccess(params));
    })
    .catch((err) => {
      dispatch(deleteFail());
      toastrError(err);
    });
};

export const updateAssociations = (params, type) => (dispatch) => {
  if (type === 'users') {
    dispatch(updateUsersRequest());
  } else if (type === 'jobs') {
    dispatch(updateJobsRequest());
  }
  return communicate({ url: 'ProjectAssociations', method: 'post', data: params })
    .then(({ data }) => {
      toastrSuccess(data);
      if (type === 'users') {
        dispatch(updateUsersSuccess(data.Data));
      } else if (type === 'jobs') {
        dispatch(updateJobsSuccess(data.Data));
      }
    })
    .catch((err) => {
      if (type === 'users') {
        dispatch(updateUsersFail());
      } else if (type === 'jobs') {
        dispatch(updateJobsFail());
      }
      toastrError(err);
    });
};

export const deleteAssociations = (params, type) => (dispatch) => {
  if (type === 'users') {
    dispatch(deleteUsersRequest());
  } else if (type === 'jobs') {
    dispatch(deleteJobsRequest());
  }
  return communicate({ url: 'ProjectAssociations', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      toastrSuccess(data);
      if (type === 'users') {
        dispatch(deleteUsersSuccess(params));
      } else if (type === 'jobs') {
        dispatch(deleteJobsSuccess(params));
      }
    })
    .catch((err) => {
      if (type === 'users') {
        dispatch(deleteUsersFail());
      } else if (type === 'jobs') {
        dispatch(deleteJobsFail());
      }
      toastrError(err);
    });
};
